import { render, staticRenderFns } from "./PollsLayout.vue?vue&type=template&id=4dc0575a&scoped=true"
import script from "./PollsLayout.vue?vue&type=script&lang=js"
export * from "./PollsLayout.vue?vue&type=script&lang=js"
import style0 from "./PollsLayout.vue?vue&type=style&index=0&id=4dc0575a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc0575a",
  null
  
)

export default component.exports